import ProspectsAndCustomersModule from "./ProspectsAndCustomersModule";
import reducer from "./redux/prospectsAndCustomersReducer";
import saga from "./redux/prospectsAndCustomersSagas";

export default {
  Component: ProspectsAndCustomersModule,
  moduleName: "prospectsCustomers",
  saga: saga(),
  reducer: reducer
};
